import { render, staticRenderFns } from "./TopSeven.vue?vue&type=template&id=37f2772c&scoped=true&"
import script from "./TopSeven.vue?vue&type=script&lang=js&"
export * from "./TopSeven.vue?vue&type=script&lang=js&"
import style0 from "./TopSeven.vue?vue&type=style&index=0&id=37f2772c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2772c",
  null
  
)

export default component.exports